import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Col, message, Row, Select, Tabs } from 'antd';

import moment from 'moment';
import {
  queryDeleteProjFiles,
  queryProjDirList,
  queryProjFilesList,
  queryProjInfo,
  queryProjStatRate,
  queryProjTaskList,
  querySaveProjFiles,
} from '@api/task';
import { BackBtn } from '@comm/BackBtn';

import { setBackInfoStandby } from '@store/modules/back_info_standby';
import TableTask from './TableTask';
import TableFiles from './TableFiles';
import ModalFileAdd from './ModalFileAdd';
import ModalFileEdit from './ModalFileEdit';
import TreeDirectory from './TreeDirectory';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projInfo: {},
      projRate: {},

      directory: '',
      directoryUuid: '',
      directoryList: [],

      taskList: [],
      filesList: [],

      taskCurrent: 1,
      filesCurrent: 1,

      taskPagination: {
        total: 10,
        current: 1,
        PageSize: 10,
      },
      filesPagination: {
        total: 10,
        current: 1,
        PageSize: 10,
      },

      tabKey: '1',
      taskType: 'All',
      editFileInfo: {},

      taskLoading: false,
      filesLoading: false,
      addFileVisible: false,
      editFileVisible: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getProjInfo();
    this.getProjStatRate();
    const directoryList = this.getDirectoryList();
    const { backInfoStandby } = this.props;
    if (backInfoStandby.path === this.props.location.pathname) {
      this.setState(
        {
          tabKey: backInfoStandby.tabKey,
          taskType: backInfoStandby.taskType,

          taskCurrent: backInfoStandby.taskCurrent,
          filesCurrent: backInfoStandby.filesCurrent,

          directory: backInfoStandby.directory,
          directoryUuid: backInfoStandby.directoryUuid,
        },
        () => {
          backInfoStandby.tabKey === '1' && this.getProjTaskList();
          backInfoStandby.tabKey === '2' && this.getProjFilesList();
        },
      );
    } else {
      directoryList
        .then(data => {
          this.setState({
            directory: data[0].name,
            directoryUuid: data[0].uuid,
          });
        })
        .then(() => {
          this.getProjTaskList();
          this.getProjFilesList();
        });
    }
  }

  componentWillUnmount() {
    const {
      tabKey,
      taskType,

      taskCurrent,
      filesCurrent,

      directory,
      directoryUuid,
    } = this.state;
    const params = {
      path: this.props.location.pathname,
      tabKey,
      taskType,

      taskCurrent,
      filesCurrent,

      directory,
      directoryUuid,
    };
    this.props.dispatch(setBackInfoStandby(params));
  }

  // 获取项目详情
  getProjInfo = () => {
    const { uuid } = this.props.params;
    queryProjInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          projInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取项目任务完成率
  getProjStatRate = () => {
    const { uuid } = this.props.params;
    queryProjStatRate({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          projRate: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 资料目录列表
  getDirectoryList = async () => {
    const { uuid } = this.props.params;
    let data;
    await queryProjDirList({
      projectUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          directoryList: res.data || [],
        });
        // eslint-disable-next-line prefer-destructuring
        data = res.data;
      } else {
        message.error(res.message, 2.5);
      }
    });
    return data;
  };

  // 获取项目下任务列表
  getProjTaskList = () => {
    const projectUuid = this.props.params.uuid;
    let { taskType } = this.state;
    const { directoryUuid, taskCurrent } = this.state;
    taskType === 'All' && (taskType = '');
    const params = {
      start: taskCurrent,
      limit: 10,
      projectUuid,
      directoryUuid,
      status: taskType,
    };
    this.setState({
      taskLoading: true,
    });
    queryProjTaskList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          taskList: res.data,
          taskPagination: {
            total: res.totalSize,
            current: taskCurrent,
            pageSize: 10,
          },
        });
      } else {
        message.error(res.message);
      }
      this.setState({
        taskLoading: false,
      });
    });
  };

  // 获取文件列表
  getProjFilesList = () => {
    const projectUuid = this.props.params.uuid;
    const { filesCurrent, directoryUuid } = this.state;
    const params = {
      start: filesCurrent,
      limit: 15,
      directoryUuid,
      projectUuid,
    };
    this.setState({
      filesLoading: true,
    });
    queryProjFilesList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          filesList: res.data,
          filesPagination: {
            total: res.totalSize,
            current: filesCurrent,
            pageSize: 15,
          },
        });
      } else {
        message.error(res.message);
      }
      this.setState({
        filesLoading: false,
      });
    });
  };

  // 资料目录选中
  handleDirectorySelect = value => {
    this.setState(
      {
        taskCurrent: 1,
        filesCurrent: 1,
        directory: value.name,
        directoryUuid: value.uuid,
      },
      () => {
        this.getProjTaskList();
        this.getProjFilesList();
      },
    );
  };

  // 新增任务
  addProjTask = () => {
    const { projInfo, directory, directoryUuid } = this.state;
    if (directoryUuid === '') {
      message.error('选择目录后，可在该目录下新增任务');
    } else {
      this.props.router.push({
        pathname: `/task/project_task_add`,
        query: {
          projectUuid: projInfo.uuid,
          projectName: projInfo.name,
          directoryUuid,
          directoryName: directory,
        },
      });
    }
  };

  // 编辑任务
  editProjTask = uuid => {
    const { projInfo, directory, directoryUuid } = this.state;
    this.props.router.push({
      pathname: `/task/project_task_edit/${uuid}`,
      query: {
        projectUuid: projInfo.uuid,
        projectName: projInfo.name,
        directoryUuid,
        directoryName: directory,
      },
    });
  };

  /** ---------------------------文件新增start---------------------------*/
  // 新增文件按钮
  addProjFile = () => {
    const { directoryUuid } = this.state;
    if (directoryUuid === '') {
      message.error('选择目录后，可在该目录下新增文件');
    } else {
      this.setState({
        addFileVisible: true,
      });
    }
  };

  // 弹窗确定上传
  addFileHandleOk = params => {
    const { directoryUuid } = this.state;
    params.projectUuid = this.props.params.uuid;
    params.directoryUuid = directoryUuid;
    querySaveProjFiles(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({
          tabKey: '2',
          addFileVisible: false,
        });
        this.getProjFilesList();
      } else {
        message.error(res.message);
      }
    });
  };

  // 弹窗关闭
  addFileHandleCancel = () => {
    this.setState({
      addFileVisible: false,
    });
  };
  /** ---------------------------文件新增end-----------------------------*/

  /** ---------------------------文件编辑start---------------------------*/
  // 编辑文件按钮
  editProjFile = record => {
    this.setState({
      editFileInfo: record,
      editFileVisible: true,
    });
  };

  // 弹窗确定上传
  editFileHandleOk = params => {
    const { directoryUuid, editFileInfo } = this.state;
    params.projectUuid = this.props.params.uuid;
    params.directoryUuid = directoryUuid;
    params.uuid = editFileInfo.uuid;
    querySaveProjFiles(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({
          editFileVisible: false,
        });
        this.getProjFilesList();
      } else {
        message.error(res.message);
      }
    });
  };

  // 弹窗关闭
  editFileHandleCancel = () => {
    this.setState({
      editFileVisible: false,
    });
  };

  /** ---------------------------文件编辑end-----------------------------*/
  // 文件删除
  delProjFile = uuid => {
    queryDeleteProjFiles({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getProjFilesList();
      } else {
        message.error(res.message);
      }
    });
  };

  // tab栏切换
  changeTabs = key => {
    key === '1' && this.setState({ tabKey: '1' });
    key === '2' && this.setState({ tabKey: '2' });
  };

  // 任务类型改变
  changeSelect = value => {
    this.setState(
      {
        taskType: value,
        taskCurrent: 1,
      },
      () => {
        this.getProjTaskList();
      },
    );
  };

  // 列表改变
  changeTaskList = pagination => {
    this.setState(
      {
        taskCurrent: pagination.current,
      },
      () => {
        this.getProjTaskList();
      },
    );
  };

  // 列表改变
  changeFilesList = pagination => {
    this.setState(
      {
        filesCurrent: pagination.current,
      },
      () => {
        this.getProjFilesList();
      },
    );
  };

  toPageInfo = () => {
    const { uuid } = this.props.params;
    this.props.router.push(`/task/project_info/${uuid}`);
  };

  render() {
    const {
      projInfo,
      projRate,

      tabKey,
      taskType,
      editFileInfo,

      directoryUuid,
      directoryList,

      taskList,
      filesList,

      taskLoading,
      filesLoading,

      taskPagination,
      filesPagination,

      addFileVisible,
      editFileVisible,
    } = this.state;
    return (
      <div>
        <Card>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <BackBtn />
              <a
                style={{
                  fontWeight: 'bolder',
                  fontSize: '20px',
                  paddingLeft: '20px',
                }}
                onClick={this.toPageInfo}
              >
                {projInfo.name}
              </a>
              <span
                style={{
                  display: 'inline-block',
                  border: '1px solid #D9D9D9',
                  borderRadius: '15%',
                  backgroundColor: '#F5F5F5',
                  marginLeft: '20px',
                  paddingLeft: '5px',
                  paddingRight: '5px',
                }}
              >
                {projInfo.endDate ? moment.unix(projInfo.endDate / 1000).format('YYYY-MM-DD') : ''}
              </span>
            </Col>
            <Col>
              <Button type="primary" style={{ marginRight: '20px' }} onClick={this.addProjTask}>
                新增任务
              </Button>
              <Button type="primary" onClick={this.addProjFile}>
                新增文件
              </Button>
            </Col>
          </Row>
        </Card>
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <TreeDirectory
                data={directoryList}
                project={projInfo.name}
                projectUuid={projInfo.uuid}
                directoryUuid={directoryUuid}
                onSelect={this.handleDirectorySelect}
                getDirectoryList={this.getDirectoryList}
              />
            </Col>
            <Col span={18}>
              <Tabs defaultActiveKey="1" activeKey={tabKey} onChange={this.changeTabs}>
                <TabPane tab="任务信息" key="1">
                  <div style={{ position: 'relative' }}>
                    <div
                      style={{
                        position: 'absolute',
                        display: 'flex',
                        top: '-55px',
                        right: '10px',
                        alignItems: 'center',
                      }}
                    >
                      <p style={{ paddingRight: '15px' }}>
                        任务数：{projRate.taskNum ? projRate.taskNum : 0}
                      </p>
                      <p style={{ paddingRight: '15px' }}>
                        完成数：
                        {projRate.taskCompletions ? projRate.taskCompletions : 0}
                      </p>
                      <p style={{ paddingRight: '15px' }}>
                        完成率：
                        {projRate.rate ? `${(projRate.rate * 100).toFixed(2)}%` : '0%'}
                      </p>
                      <Select
                        value={taskType}
                        onChange={this.changeSelect}
                        style={{ width: '120px', marginBottom: '10px' }}
                      >
                        <Select.Option key="All">全部</Select.Option>
                        <Select.Option key="PUBLISH">发布中</Select.Option>
                        <Select.Option key="FINISH">已结束</Select.Option>
                        <Select.Option key="DRAFT">草稿箱</Select.Option>
                      </Select>
                    </div>
                    <TableTask
                      data={taskList}
                      isLoading={taskLoading}
                      pagination={taskPagination}
                      onChange={this.changeTaskList}
                      editProjTask={this.editProjTask}
                      getProjTaskList={this.getProjTaskList}
                      {...this.props}
                    />
                  </div>
                </TabPane>
                <TabPane tab="相关文件" key="2">
                  <TableFiles
                    data={filesList}
                    isLoading={filesLoading}
                    pagination={filesPagination}
                    delProjFile={this.delProjFile}
                    editProjFile={this.editProjFile}
                    onChange={this.changeFilesList}
                    {...this.props}
                  />
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        </Card>
        <ModalFileAdd
          visible={addFileVisible}
          onOk={this.addFileHandleOk}
          onCancel={this.addFileHandleCancel}
          delFiles={this.delFiles}
          {...this.props}
        />
        <ModalFileEdit
          visible={editFileVisible}
          fileName={editFileInfo.name}
          onOk={this.editFileHandleOk}
          onCancel={this.editFileHandleCancel}
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(state => ({
  uesrInfo: state.account_info,
  backInfoStandby: state.back_info_standby,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetailManage/Index.js